export enum CREATE_BUSINESS {
    REQUEST = 'CREATE_BUSINESS_REQUEST',
    SUCCESS = 'CREATE_BUSINESS_SUCCESS',
    FAILURE = 'CREATE_BUSINESS_FAILURE'
}

export enum FETCH_ALL_BUSINESSES {
    REQUEST = 'FETCH_ALL_BUSINESSES_REQUEST',
    SUCCESS = 'FETCH_ALL_BUSINESSES_SUCCESS',
    FAILURE = 'FETCH_ALL_BUSINESSES_FAILURE'
}

export enum FETCH_BUSINESS {
    REQUEST = 'FETCH_BUSINESS_REQUEST',
    SUCCESS = 'FETCH_BUSINESS_SUCCESS',
    FAILURE = 'FETCH_BUSINESS_FAILURE'
}

export enum SAVE_BUSINESS {
    REQUEST = 'SAVE_BUSINESS_REQUEST',
    SUCCESS = 'SAVE_BUSINESS_SUCCESS',
    FAILURE = 'SAVE_BUSINESS_FAILURE'
}

export enum SAVE_BUSINESS_STATUS {
    REQUEST = 'SAVE_BUSINESS_STATUS_REQUEST',
    SUCCESS = 'SAVE_BUSINESS_STATUS_SUCCESS',
    FAILURE = 'SAVE_BUSINESS_STATUS_FAILURE'
}

export enum BUSINESS {
    EDIT = 'BUSINESS_EDIT',
    RESET = 'BUSINESS_RESET'
}

export enum FETCH_BUSINESS_DATASET {
    REQUEST = 'FETCH_BUSINESS_DATASET_REQUEST',
    SUCCESS = 'FETCH_BUSINESS_DATASET_SUCCESS',
    FAILURE = 'FETCH_BUSINESS_DATASET_FAILURE'
}